import Vue from 'vue';
import pTrans from './../../transformers/productWarehouse';

const success = ({ data }, resolve) => {
  const product = pTrans.fetch(data);
  resolve(product);
};

const failed = () => {};

export default (id, warehouseId, batchId = '') => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`/stocks/find-product/${warehouseId}/${id}/${batchId}`)
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/stock/warehouseProduct.js